export default __webpack_public_path__ + "static/media/advanced-filters-active.0ae9ca4a.svg";